// offline/arranquePendiente.js -- camara-pills (seccion 6, regla de Carlos del 24-oct).
//
// ARCHIVO EN ASCII A PROPOSITO.
//
// "La app abre directo el Panel, siempre y al instante, tenga o no internet." Con sesion
// guardada y bodega del MISMO dueno, `AuthContext.fetchUser` pinta al usuario de la bodega en
// el primer momento y pregunta `/auth/me` por detras. Mientras esa pregunta no contesta, el
// arranque esta PENDIENTE: no se sabe si hay red ni si la sesion sigue viva.
//
// Esta marca es lo unico que necesitan saber las pantallas que eligen fuente de datos (hoy, el
// Panel): con el arranque pendiente se pinta lo local, como con el dictamen de "sin senal",
// pero SIN encender el estado de "sin conexion" (no es un arranque sin red: es un arranque que
// todavia no sabe). Cuando `/auth/me` contesta, la marca se apaga y el `setUser` del usuario
// fresco vuelve a pedir lo vivo, como la normalizacion de siempre.
//
// Modulo con estado, sin imports, como el veredicto de red: nadie lo escribe salvo AuthContext.

let pendiente = false;

/** AuthContext: el arranque pinto de la bodega y espera `/auth/me` (true), o ya contesto (false). */
export function marcarArranquePendiente(valor) {
  pendiente = Boolean(valor);
}

/** Las pantallas: con el arranque pendiente se pinta lo local. */
export function arranquePendiente() {
  return pendiente;
}
